function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.5001 2.74805C16.9413 2.76638 17.2966 2.91537 17.566 3.19503C17.8355 3.47468 17.9802 3.82572 18.0001 4.24815V17.2481C18.0001 17.6521 17.8554 18.0016 17.566 18.2968C17.2767 18.592 16.9113 18.7425 16.47 18.7481L13 18.748L13.0001 22.7481H11.0001L11 18.748L7.50008 18.7481C7.08429 18.7481 6.72962 18.5977 6.43609 18.2968C6.14255 17.996 5.9972 17.6464 6.00004 17.2481V4.24815C6.01631 3.82913 6.16166 3.47809 6.43609 3.19503C6.71052 2.91197 7.06519 2.76297 7.50008 2.74805H16.5001ZM11.0001 14.7481H9.00008V16.7481H11.0001V14.7481ZM15.0001 14.7481H13.0001V16.7481H15.0001V14.7481ZM16.0001 4.74815H8.00008V12.7481H16.0001V4.74815ZM12.0001 6.24815C13.3334 7.51177 14.0001 8.51177 14.0001 9.24815C14.0001 10.3527 13.1047 11.2481 12.0001 11.2481C10.8955 11.2481 10.0001 10.3527 10.0001 9.24815C10.0001 8.51177 10.6667 7.51177 12.0001 6.24815Z",
  fill: "#AB00E7"
});

var SvgGlucometer = function SvgGlucometer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGlucometer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/glucometer.e961a4c5.svg";
export { ForwardRef as ReactComponent };